import { ReactNode } from "react";
import ReactDOM from "react-dom";

export function Modal(props: { children: ReactNode }) {
	const modalContainer = document.getElementById("app-modal");

	if (!modalContainer) {
		console.error("Modal container is null!");
		return null;
	}

	return ReactDOM.createPortal(props.children, modalContainer);
}
